// extracted by mini-css-extract-plugin
module.exports =  {"section":"_32bbee5fda--section--W2MK5","left-column":"_32bbee5fda--left-column--OOnwy","right-column":"_32bbee5fda--right-column--XWlCF"};